module.exports = __webpack_public_path__ + "./JenniePhoto_3834a80e32bebb66188e67ba867f3e54.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2021/JenniePhoto.png
// module id = 529
// module chunks = 0